import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import { lightTheme } from "./theme/Theme";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { CookiesProvider } from "react-cookie";
import "./index.css";

import { RolesProvider } from "./contexts/RolesContext";

const container = document.getElementById("root");
const root = createRoot(container);

console.log("🚀 ~ App Env:", process.env.REACT_APP_ENV);

if (process.env.REACT_APP_ENV === "development") {
  const { worker } = require("./mocks/browser");
  worker.start();
}

root.render(
  <React.StrictMode>
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <RolesProvider>
        <Provider store={store}>
          <BrowserRouter>
            <CookiesProvider defaultSetOptions={{ path: "/" }}>
              <SnackbarProvider>
                <App />
              </SnackbarProvider>
            </CookiesProvider>
          </BrowserRouter>
        </Provider>
      </RolesProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
